import fetch from 'fetch'
import ImgVerifyCode from 'imgVerifyCode'
import {shared as progress} from 'progress'
// import commonconfig from 'commonconfig'

class VerifyCode {
  constructor ($btn, $mobile, url, config, sendData) {
    config = config || {}
    this.$btnGetCode = $btn
    this.$mobile = $mobile
    this.secondsLeft = 0
    this.itv = null
    this.url = url
    this.noImgVerify = config.noImgVerify
    this.sendData = sendData || {}
    this.imgVerifyCode = new ImgVerifyCode(true)

    this.$btnGetCode.click(() => {
      if (this.$btnGetCode.hasClass('unavailable')) {
        return
      }
      // commonconfig.get().then((data) => {
      //   data.smsCaptchaOn = true
      //   if (data.smsCaptchaOn && !this.noImgVerify) {
      //     imgVerifyCode.show()
      //   } else {
      //     this.getCode()
      //   }
      // })
      this.getCode()
    })

    this.imgVerifyCode.on('confirm', (captcha) => {
      this.getCode(captcha)
    })
  }
  reset () {
    this.secondsLeft = 0
    clearInterval(this.itv)
    this.$btnGetCode.removeClass('unavailable')
    this.$btnGetCode.text('获取验证码')
  }
  getCode (captcha) {
    this.secondsLeft = 60
    this.requesting = true
    this.sendData.ua = this.$mobile.val().replaceAll(' ', '')    
    // var data = {
    //   'ua': this.$mobile.val()
    // }
    if (captcha) {
      this.sendData.captcha = captcha
    } else {
      delete this.sendData.captcha
    }

    fetch({
      method: 'post',
      url: this.url,
      data: this.sendData
    })
      .on('success', (res) => {
        if (this.url.indexOf('v3/user') === -1) {
          this.countDown()
          this.itv = setInterval(this.countDown.bind(this), 1000)
          return false
        }
        if (res.success) {
          this.imgVerifyCode.hide()
          this.countDown()
          this.itv = setInterval(this.countDown.bind(this), 1000)
        } else if (res.needCaptcha) {
          if (res.errorMsg !== '请输入图形验证码') {
            progress.showMessage(res.errorMsg)
          }
          this.imgVerifyCode.show()
        } else {          
          progress.showMessage(res.errorMsg)
        }
      })
      .on('error', (err) => {
        progress.showMessage(err)
      })
      .on('complete', () => {
        this.requesting = false
      })
  }
  countDown () {
    if (this.secondsLeft === 0) {
      this.$btnGetCode.removeClass('unavailable')
      this.$btnGetCode.css('opacity', '')
      this.$btnGetCode.html('获取验证码')
      clearInterval(this.itv)
    } else {
      this.$btnGetCode.addClass('unavailable')
      this.$btnGetCode.css('opacity', 0.5)
      this.$btnGetCode.html(`重新发送(${this.secondsLeft})`)
    }
    this.secondsLeft--
  }
}

export default VerifyCode



// WEBPACK FOOTER //
// ./src/mods/VerifyCode.js